import User from "@Components/app/members/teamInterfaces";
import { Subscription } from "@Globals/types";
import { AuthErrorCode } from "@Services/auth-service";

export function titleCase(str: string) {
    if( !str ) {
        return "";
    }
    return str.toLowerCase().split(' ').map(function (word) {
        return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
}

export function delay(time: number) {
    return new Promise(resolve => setTimeout(resolve, time));
}

export function displayName(user?: User) {
    return `${user ? titleCase(`${user.first} ${user.last}`).trim() : ""}`;
}

export interface Filterable {
    filterString: string
}

export function filterItem(filter: string, item: Filterable) {
    return !filter || (item.filterString.indexOf(filter) > -1);
};

export function sortFilterables(a: Filterable, b: Filterable) {
    return a.filterString.localeCompare(b.filterString);
};

function getSubscriptionRank(sub: Subscription) {

    if(!sub.type) {
        return 0;
    }

    switch(sub.type.toUpperCase()) {
        case "PLATFORM_ACCESS":
            return 32;
        case "FEATURE_SWITCH":
            return 16;
        case "STYLE_ENV":
            return 8;
        case "STYLE_TEAM":
            return 4;
        default:
            return 0;
    }
}

export function sortSubscriptions(a: Subscription, b: Subscription) {

    if( !a.type && b.type ) return 1;
    if( !b.type && a.type ) return -1;
    if( !a.type && !b.type) return 0;

    let diff = getSubscriptionRank(b) - getSubscriptionRank(a);
    if( diff !== 0 ) {
        return diff;
    }

    diff = a.type.localeCompare(b.type);
    if( diff !== 0 ) {
        return diff;
    }

    if( a.id && b.id ) {
        return a.id.localeCompare(b.id);
    }

    return 0;
}

export interface Nameable {
    name: string,
    first: string,
    last: string
}

export interface TeamNameable {
    teamName: string,
    name: string,
    group: string
}

export function compareName(a: Nameable, b: Nameable) {
    return a.name.localeCompare(b.name);
}

export function populateNames(data: Nameable[]) {
    for(let i = 0; i < data.length; i++) {
        data[i].name = `${data[i].first} ${data[i].last}`.toLowerCase();
    }
}

export function compareTeamName(a: TeamNameable, b: TeamNameable) {
    return a.teamName.localeCompare(b.teamName);
}

export function populateTeamNames(data: TeamNameable[]) {
    for(let i = 0; i < data.length; i++) {
        data[i].teamName = `${data[i].name} ${data[i].group}`.toLowerCase();
    } 
}

export function getAuthErrorMessage(errorCode: string) {
    switch(errorCode) {
        case AuthErrorCode.EmailAlreadyExists:
            return 'auth.email-already-exists';
        case AuthErrorCode.WrongPassword:
            return 'auth.wrong-password';
        case AuthErrorCode.TooManyRequests:
            return 'auth.too-many-requests';
        case AuthErrorCode.NetworkRequestFailed:
            return 'error.network-failure';
        case AuthErrorCode.UserNotFound:
            return 'auth.user-not-found';
        case AuthErrorCode.InvalidEmail:
            return 'auth.invalid-email';
        case AuthErrorCode.MissingEmail:
            return 'auth.missing-email';
    }
    return 'error.generic';
}

export function getDisplayNumber(n: number, decimals?: number) {
  if (!(n > 0)) return "0";
  const decimals_ = decimals || Math.max(0, 2 - Math.floor(Math.log10(Math.abs(n))));
  return parseFloat(n.toFixed(decimals_)).toLocaleString();
}